export const MEDIA_ASSET_SIZE_LIMIT_MB = 100;

export const MEDIA_ASSET_IMAGE_MIME_TYPES = {
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/gif': 'gif',
};

export const MEDIA_ASSET_VIDEO_MIME_TYPES = {
  'video/mp4': 'mp4',
  'video/webm': 'webm',
  'video/ogg': 'ogg',
  'video/quicktime': 'mov',
};
